import { useEffect, useRef } from "react";
import { Reveal, SectionHeader } from "./Reveal";
import LogoChip from "./LogoChip";
import { CUSTOMERS } from "../data/site";

const Row = ({ names }) => (
  <div className="flex shrink-0 items-center gap-5 pr-5">
    {names.map((c) => (
      <LogoChip
        key={c.name}
        name={c.name}
        domain={c.domain}
        img={c.img}
        boost={c.boost}
        className="shrink-0 rounded-2xl px-6 py-5 transition-transform duration-300 hover:-translate-y-1"
        imgClass="h-11 w-[150px]"
        fallbackClass="font-display text-base font-bold uppercase tracking-wide text-navy-deep whitespace-nowrap w-[150px] text-center"
      />
    ))}
  </div>
);

const Customers = () => {
  const trackRef = useRef(null);
  const offset = useRef(0);
  const dragging = useRef(false);
  const lastX = useRef(0);

  useEffect(() => {
    const track = trackRef.current;
    let raf;
    const loop = () => {
      const half = track.scrollWidth / 2;
      if (half > 0) {
        if (!dragging.current) offset.current -= 0.5;
        if (offset.current <= -half) offset.current += half;
        if (offset.current > 0) offset.current -= half;
        track.style.transform = `translateX(${offset.current}px)`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  const down = (e) => {
    dragging.current = true;
    lastX.current = e.clientX;
  };
  const move = (e) => {
    if (!dragging.current) return;
    offset.current += e.clientX - lastX.current;
    lastX.current = e.clientX;
  };
  const up = () => { dragging.current = false; };

  return (
    <section id="customers" data-testid="customers-section" className="relative py-28 md:py-36 overflow-hidden bg-navy-dark/40">
      <div className="max-w-6xl mx-auto px-6">
        <SectionHeader
          index={6}
          overline="Happy Customers"
          title={<>Trusted by organizations<br /><span className="text-smipl-orange">across industries.</span></>}
        />
      </div>
      <Reveal>
        <div
          className="relative cursor-grab active:cursor-grabbing select-none"
          data-testid="customer-marquee"
          onPointerDown={down}
          onPointerMove={move}
          onPointerUp={up}
          onPointerLeave={up}
        >
          <div className="pointer-events-none absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-navy-deep to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-navy-deep to-transparent" />
          <div ref={trackRef} className="flex w-max will-change-transform">
            <Row names={CUSTOMERS} />
            <Row names={CUSTOMERS} />
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-10 text-center font-mono text-[11px] tracking-[0.3em] uppercase text-slate-600">
          Drag to explore · Banking · Manufacturing · Healthcare · Steel · Mining · Technology
        </p>
      </Reveal>
    </section>
  );
};

export default Customers;
